var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow && _vm.bankName),expression:"isShow && bankName"}],staticClass:"bottom-info",class:_vm.isRelative ? 'relative' : ''},[_vm._v("该信息由"+_vm._s(_vm.bankName)+"提供")])])
}
var staticRenderFns = []

export { render, staticRenderFns }